<template>
  <div>
    <top-navbar></top-navbar>

    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Microsoft Excel Upload
      </h6>

      <div class="container-fluid" style="padding-bottom: 120px;">
        <div class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-start flex-wrap mb-3">
              <div>
                <h5 class="mb-1">Upload Excel To Personal OneDrive</h5>
                <p class="text-muted mb-0">
                  Sign in with your personal Microsoft account, upload Excel files, and load them again through Microsoft Graph API.
                </p>
              </div>
              <div class="mt-2 mt-md-0">
                <button
                  v-if="!isConnected"
                  type="button"
                  class="btn btn-outline-primary font-size_def bdr-rad"
                  :disabled="authenticating"
                  @click="signInWithMicrosoft"
                >
                  {{ authenticating ? "Connecting..." : "Sign In With Microsoft" }}
                </button>
                <button
                  v-else
                  type="button"
                  class="btn btn-outline-danger font-size_def bdr-rad"
                  @click="disconnectMicrosoft"
                >
                  Disconnect
                </button>
              </div>
            </div>

            <div class="alert alert-info small" role="alert">
              Azure setup needed once:
              change your app registration to support <b>personal Microsoft accounts</b>,
              add the <b>SPA redirect URI</b> <code>{{ config.redirect_uri || 'http://localhost:8080/microsoft/callback' }}</code>,
              and keep delegated Graph permissions <b>User.Read</b>, <b>Files.Read</b>, <b>Files.ReadWrite</b>, and <b>offline_access</b>.
            </div>

            <div v-if="account.display_name || account.email" class="alert alert-success small" role="alert">
              Connected account:
              <b>{{ account.display_name || "-" }}</b>
              <span v-if="account.email">({{ account.email }})</span>
            </div>

            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label class="custom-label small-label">OneDrive Folder Path</label>
                  <input
                    v-model="form.folder_path"
                    type="text"
                    class="form-control bdr-rad font-size_def"
                    placeholder="Reports/Excel"
                  />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label class="custom-label small-label">Excel File</label>
                  <input
                    ref="excelFile"
                    type="file"
                    accept=".xls,.xlsx,.csv"
                    class="form-control bdr-rad font-size_def"
                    @change="onFileSelected"
                  />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label class="custom-label small-label">Current Status</label>
                  <input
                    :value="statusLabel"
                    type="text"
                    readonly
                    class="form-control bdr-rad font-size_def bg-light"
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label class="custom-label small-label">Client ID</label>
                  <input :value="config.client_id" type="text" readonly class="form-control bdr-rad font-size_def bg-light" />
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-group">
                  <label class="custom-label small-label">OAuth Tenant</label>
                  <input :value="config.oauth_tenant" type="text" readonly class="form-control bdr-rad font-size_def bg-light" />
                </div>
              </div>

              <div class="col-md-3 d-flex align-items-end">
                <div class="form-group w-100">
                  <button
                    type="button"
                    class="btn btn-primary w-100 font-size_def bdr-rad"
                    :disabled="uploading || !isConnected"
                    @click="uploadFile"
                  >
                    {{ uploading ? "Uploading..." : "Upload Excel" }}
                  </button>
                </div>
              </div>

              <div class="col-md-3 d-flex align-items-end">
                <div class="form-group w-100">
                  <button
                    type="button"
                    class="btn btn-outline-primary w-100 font-size_def bdr-rad"
                    :disabled="loadingFiles || !isConnected"
                    @click="loadFiles"
                  >
                    {{ loadingFiles ? "Loading..." : "Load Files" }}
                  </button>
                </div>
              </div>
            </div>

            <div v-if="result" class="card custom_bdr_rds shadow p-2 mt-4">
              <div class="card-body custom_bdr_rds">
                <h6 class="purchitem mb-2"><b>Upload Result</b></h6>
                <table style="font-size: small;" class="table table-sm table-borderless mb-0">
                  <tbody>
                    <tr>
                      <td class="width-custom2"><b>Status</b></td>
                      <td>{{ result.message || "-" }}</td>
                    </tr>
                    <tr>
                      <td><b>File Name</b></td>
                      <td>{{ result.data && result.data.name ? result.data.name : "-" }}</td>
                    </tr>
                    <tr>
                      <td><b>Folder</b></td>
                      <td>{{ result.data && result.data.folder_path ? result.data.folder_path : "-" }}</td>
                    </tr>
                    <tr>
                      <td><b>View File</b></td>
                      <td>
                        <a
                          v-if="result.data && result.data.web_url"
                          :href="result.data.web_url"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Open in OneDrive
                        </a>
                        <span v-else>-</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div v-if="files.length" class="card custom_bdr_rds shadow p-2 mt-4">
              <div class="card-body custom_bdr_rds">
                <div class="d-flex justify-content-between align-items-center mb-2 flex-wrap">
                  <h6 class="purchitem mb-0"><b>Files In Folder</b></h6>
                  <small class="text-muted">{{ form.folder_path || "Root folder" }}</small>
                </div>

                <div class="table-responsive">
                  <table style="font-size: small;" class="table table-hover table-sm table-borderless">
                    <thead class="background_color2">
                      <tr class="custom-label2">
                        <th>#</th>
                        <th>Name</th>
                        <th>Size</th>
                        <th>Modified</th>
                        <th class="text_right">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in files" :key="item.id || index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.name || "-" }}</td>
                        <td>{{ formatBytes(item.size) }}</td>
                        <td>{{ item.lastModifiedDateTime || "-" }}</td>
                        <td class="text_right">
                          <a
                            v-if="item.webUrl"
                            :href="item.webUrl"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="btn btn-sm btn-outline-primary bdr-rad font-size_def"
                          >
                            View
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div v-if="errorMessage" class="alert alert-danger mt-4 mb-0" role="alert">
              {{ errorMessage }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from "axios";
import authService from "@/auth.service";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";

const STORAGE_KEYS = {
  token: "MS_PERSONAL_TOKEN",
  verifier: "MS_PERSONAL_PKCE_VERIFIER",
  state: "MS_PERSONAL_AUTH_STATE",
};

function createForm() {
  return {
    folder_path: "Reports/Excel",
    file: null,
  };
}

function base64UrlEncode(buffer) {
  const bytes = new Uint8Array(buffer);
  let binary = "";

  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });

  return window.btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
}

function randomString(length = 64) {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
  let result = "";
  const randomValues = new Uint32Array(length);
  window.crypto.getRandomValues(randomValues);

  for (let i = 0; i < length; i += 1) {
    result += characters[randomValues[i] % characters.length];
  }

  return result;
}

export default {
  components: {
    TopNavbar,
    ContentFooter,
  },

  data() {
    return {
      access_token: authService.isLoggedIn(),
      authenticating: false,
      uploading: false,
      loadingFiles: false,
      form: createForm(),
      config: {
        client_id: "6d9e79d9-23d6-4b09-9586-1ae6a144ef9e",
        tenant_id: "",
        oauth_tenant: "consumers",
        redirect_uri: "http://localhost:8080/microsoft/callback",
        scopes: ["User.Read", "Files.Read", "Files.ReadWrite", "offline_access"],
      },
      result: null,
      errorMessage: "",
      files: [],
      tokenState: null,
      authPopup: null,
      authPopupWatcher: null,
      account: {
        display_name: "",
        email: "",
      },
    };
  },

  computed: {
    isConnected() {
      return !!(this.tokenState && this.tokenState.access_token);
    },

    statusLabel() {
      if (this.authenticating) {
        return "Connecting to Microsoft...";
      }

      if (this.uploading) {
        return "Uploading to OneDrive...";
      }

      if (this.loadingFiles) {
        return "Loading files from OneDrive...";
      }

      return this.isConnected ? "Connected to Microsoft" : "Not connected";
    },
  },

  mounted() {
    this.loadConfig();
    this.handleMicrosoftMessage = this.handleMicrosoftMessage.bind(this);
    window.addEventListener("message", this.handleMicrosoftMessage);
    this.restoreMicrosoftSession();
  },

  beforeDestroy() {
    window.removeEventListener("message", this.handleMicrosoftMessage);
    this.stopAuthPopupWatcher();
  },

  methods: {
    async loadConfig() {
      try {
        const { data } = await axios.get("/microsoft/config", {
          headers: {
            Authorization: "Bearer " + this.access_token,
            "Content-type": "application/json",
          },
        });

        if (data.status === 200 && data.data) {
          this.config.client_id = data.data.client_id || "";
          this.config.tenant_id = data.data.tenant_id || "";
          this.config.oauth_tenant = data.data.oauth_tenant || "consumers";
          this.config.redirect_uri = data.data.redirect_uri || "http://localhost:8080/microsoft/callback";
          this.config.scopes =
            Array.isArray(data.data.scopes) && data.data.scopes.length
              ? data.data.scopes
              : ["User.Read", "Files.Read", "Files.ReadWrite", "offline_access"];
        }
      } catch (error) {
        console.error(error.response || error);
      }
    },

    async restoreMicrosoftSession() {
      const tokenData = this.getStoredToken();
      this.tokenState = tokenData;
      if (!tokenData) {
        return;
      }

      try {
        await this.ensureValidAccessToken();
        await this.loadProfile();
      } catch (error) {
        this.disconnectMicrosoft();
      }
    },

    getStoredToken() {
      try {
        const raw = localStorage.getItem(STORAGE_KEYS.token);
        return raw ? JSON.parse(raw) : null;
      } catch (error) {
        return null;
      }
    },

    setStoredToken(data) {
      localStorage.setItem(STORAGE_KEYS.token, JSON.stringify(data));
      this.tokenState = data;
    },

    clearStoredToken() {
      localStorage.removeItem(STORAGE_KEYS.token);
      this.tokenState = null;
    },

    onFileSelected(event) {
      const files = event.target.files || [];
      this.form.file = files.length ? files[0] : null;
    },

    disconnectMicrosoft() {
      this.stopAuthPopupWatcher();
      this.clearStoredToken();
      sessionStorage.removeItem(STORAGE_KEYS.verifier);
      sessionStorage.removeItem(STORAGE_KEYS.state);
      this.account = { display_name: "", email: "" };
      this.result = null;
      this.files = [];
      this.errorMessage = "";
      this.authenticating = false;
      this.authPopup = null;
    },

    stopAuthPopupWatcher() {
      if (this.authPopupWatcher) {
        window.clearInterval(this.authPopupWatcher);
        this.authPopupWatcher = null;
      }
    },

    async signInWithMicrosoft() {
      this.errorMessage = "";
      this.authenticating = true;

      try {
        if (!this.config.client_id) {
          throw new Error("Microsoft Client ID is missing. Please reload the page and try again.");
        }

        const verifier = randomString(96);
        const state = randomString(48);
        const challengeBuffer = await window.crypto.subtle.digest("SHA-256", new TextEncoder().encode(verifier));
        const challenge = base64UrlEncode(challengeBuffer);

        sessionStorage.setItem(STORAGE_KEYS.verifier, verifier);
        sessionStorage.setItem(STORAGE_KEYS.state, state);

        const scope = ["openid", "profile", ...this.config.scopes].join(" ");
        const authUrl =
          "https://login.microsoftonline.com/" +
          encodeURIComponent(this.config.oauth_tenant || "consumers") +
          "/oauth2/v2.0/authorize" +
          "?client_id=" + encodeURIComponent(this.config.client_id) +
          "&response_type=code" +
          "&redirect_uri=" + encodeURIComponent(this.config.redirect_uri) +
          "&response_mode=query" +
          "&scope=" + encodeURIComponent(scope) +
          "&state=" + encodeURIComponent(state) +
          "&code_challenge=" + encodeURIComponent(challenge) +
          "&code_challenge_method=S256";

        const popup = window.open(authUrl, "microsoft-login", "width=600,height=720");
        if (!popup) {
          throw new Error("Popup blocked. Please allow popups for this site.");
        }

        this.authPopup = popup;
        this.stopAuthPopupWatcher();
        this.authPopupWatcher = window.setInterval(() => {
          if (this.authPopup && this.authPopup.closed) {
            this.stopAuthPopupWatcher();
            this.authPopup = null;

            if (this.authenticating) {
              this.authenticating = false;
              this.errorMessage = "Microsoft sign-in was cancelled or closed before completion.";
            }
          }
        }, 500);
      } catch (error) {
        this.errorMessage = error.message || "Unable to start Microsoft sign-in.";
        this.authenticating = false;
      }
    },

    async handleMicrosoftMessage(event) {
      if (!event || !event.data || event.data.type !== "microsoft-auth-code") {
        return;
      }

      this.stopAuthPopupWatcher();
      this.authPopup = null;

      if (event.data.error) {
        this.errorMessage = event.data.error;
        this.authenticating = false;
        return;
      }

      try {
        await this.exchangeCodeForToken(event.data.code, event.data.state);
        await this.loadProfile();
      } catch (error) {
        this.errorMessage = error.message || "Microsoft sign-in failed.";
      } finally {
        this.authenticating = false;
      }
    },

    async exchangeCodeForToken(code, state) {
      const savedState = sessionStorage.getItem(STORAGE_KEYS.state);
      const verifier = sessionStorage.getItem(STORAGE_KEYS.verifier);

      if (!savedState || savedState !== state) {
        throw new Error("Microsoft login state did not match.");
      }

      if (!verifier) {
        throw new Error("Microsoft PKCE verifier was not found.");
      }

      const body = new URLSearchParams();
      body.append("client_id", this.config.client_id);
      body.append("grant_type", "authorization_code");
      body.append("code", code);
      body.append("redirect_uri", this.config.redirect_uri);
      body.append("code_verifier", verifier);
      body.append("scope", ["openid", "profile", ...this.config.scopes].join(" "));

      const response = await fetch(
        "https://login.microsoftonline.com/" +
          encodeURIComponent(this.config.oauth_tenant || "consumers") +
          "/oauth2/v2.0/token",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: body.toString(),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error_description || data.error || "Unable to get Microsoft access token.");
      }

      this.setStoredToken({
        access_token: data.access_token,
        refresh_token: data.refresh_token,
        expires_at: Date.now() + ((data.expires_in || 3600) * 1000),
      });

      sessionStorage.removeItem(STORAGE_KEYS.verifier);
      sessionStorage.removeItem(STORAGE_KEYS.state);
    },

    async refreshAccessToken() {
      const tokenData = this.getStoredToken();
      if (!tokenData || !tokenData.refresh_token) {
        throw new Error("Microsoft refresh token was not found.");
      }

      const body = new URLSearchParams();
      body.append("client_id", this.config.client_id);
      body.append("grant_type", "refresh_token");
      body.append("refresh_token", tokenData.refresh_token);
      body.append("redirect_uri", this.config.redirect_uri);
      body.append("scope", ["openid", "profile", ...this.config.scopes].join(" "));

      const response = await fetch(
        "https://login.microsoftonline.com/" +
          encodeURIComponent(this.config.oauth_tenant || "consumers") +
          "/oauth2/v2.0/token",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: body.toString(),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error_description || data.error || "Unable to refresh Microsoft access token.");
      }

      this.setStoredToken({
        access_token: data.access_token,
        refresh_token: data.refresh_token || tokenData.refresh_token,
        expires_at: Date.now() + ((data.expires_in || 3600) * 1000),
      });

      return data.access_token;
    },

    async ensureValidAccessToken() {
      const tokenData = this.getStoredToken();
      if (!tokenData || !tokenData.access_token) {
        throw new Error("Microsoft account is not connected.");
      }

      const expiresSoon = !tokenData.expires_at || Date.now() > tokenData.expires_at - 60000;
      if (expiresSoon) {
        return this.refreshAccessToken();
      }

      return tokenData.access_token;
    },

    async graphRequest(url, options = {}) {
      const token = await this.ensureValidAccessToken();
      const headers = options.headers ? { ...options.headers } : {};

      if (!headers.Authorization) {
        headers.Authorization = "Bearer " + token;
      }

      const response = await fetch(url, {
        ...options,
        headers,
      });

      const contentType = response.headers.get("content-type") || "";
      const data = contentType.includes("application/json")
        ? await response.json()
        : await response.text();

      if (!response.ok) {
        const message =
          data && data.error && data.error.message
            ? data.error.message
            : typeof data === "string" && data
              ? data
              : "Microsoft Graph request failed.";

        throw new Error(message);
      }

      return data;
    },

    async loadProfile() {
      const profile = await this.graphRequest("https://graph.microsoft.com/v1.0/me");
      this.account = {
        display_name: profile.displayName || "",
        email: profile.userPrincipalName || profile.mail || "",
      };
    },

    buildRemotePath() {
      const folderPath = (this.form.folder_path || "").replace(/\\/g, "/").replace(/^\/+|\/+$/g, "");
      const fileName = this.form.file ? this.form.file.name : "";

      if (!folderPath) {
        return fileName;
      }

      return folderPath + "/" + fileName;
    },

    async uploadFile() {
      this.errorMessage = "";
      this.result = null;

      if (!this.isConnected) {
        this.errorMessage = "Please sign in with Microsoft first.";
        return;
      }

      if (!this.form.file) {
        this.errorMessage = "Please choose an Excel file.";
        return;
      }

      this.uploading = true;

      try {
        const remotePath = this.buildRemotePath();
        const sessionData = await this.graphRequest(
          "https://graph.microsoft.com/v1.0/me/drive/root:/" +
            remotePath.split("/").map((segment) => encodeURIComponent(segment)).join("/") +
            ":/createUploadSession",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              item: {
                "@microsoft.graph.conflictBehavior": "rename",
              },
            }),
          }
        );

        const uploadInfo = await this.uploadFileByChunks(sessionData.uploadUrl, this.form.file);

        this.result = {
          message: "Excel file uploaded to your personal OneDrive successfully.",
          data: {
            name: uploadInfo.name || this.form.file.name,
            folder_path: this.form.folder_path || "",
            web_url: uploadInfo.webUrl || null,
          },
        };

        await this.loadFiles();
      } catch (error) {
        this.errorMessage = error.message || "An error occurred while uploading to Microsoft.";
      } finally {
        this.uploading = false;
      }
    },

    async uploadFileByChunks(uploadUrl, file) {
      const chunkSize = 3276800;
      let start = 0;
      let uploadResult = null;

      while (start < file.size) {
        const chunk = file.slice(start, start + chunkSize);
        const end = start + chunk.size - 1;

        const response = await fetch(uploadUrl, {
          method: "PUT",
          headers: {
            "Content-Length": String(chunk.size),
            "Content-Range": "bytes " + start + "-" + end + "/" + file.size,
          },
          body: chunk,
        });

        const contentType = response.headers.get("content-type") || "";
        const data = contentType.includes("application/json")
          ? await response.json()
          : await response.text();

        if (!response.ok) {
          const message =
            data && data.error && data.error.message
              ? data.error.message
              : typeof data === "string" && data
                ? data
                : "Microsoft chunk upload failed.";

          throw new Error(message);
        }

        if (data && data.id) {
          uploadResult = data;
          break;
        }

        start = end + 1;
      }

      if (!uploadResult) {
        throw new Error("Microsoft upload finished without a file result.");
      }

      return uploadResult;
    },

    async loadFiles() {
      this.errorMessage = "";

      if (!this.isConnected) {
        this.errorMessage = "Please sign in with Microsoft first.";
        return;
      }

      this.loadingFiles = true;

      try {
        const folderPath = (this.form.folder_path || "").replace(/\\/g, "/").replace(/^\/+|\/+$/g, "");
        const url = folderPath
          ? "https://graph.microsoft.com/v1.0/me/drive/root:/" +
            folderPath.split("/").map((segment) => encodeURIComponent(segment)).join("/") +
            ":/children"
          : "https://graph.microsoft.com/v1.0/me/drive/root/children";

        const data = await this.graphRequest(url);
        this.files = Array.isArray(data.value) ? data.value : [];
      } catch (error) {
        this.errorMessage = error.message || "Unable to load OneDrive files.";
      } finally {
        this.loadingFiles = false;
      }
    },

    formatBytes(bytes) {
      if (!bytes && bytes !== 0) {
        return "-";
      }

      if (bytes === 0) {
        return "0 B";
      }

      const units = ["B", "KB", "MB", "GB"];
      const index = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
      const value = bytes / Math.pow(1024, index);
      return value.toFixed(index === 0 ? 0 : 2) + " " + units[index];
    },
  },
};
</script>
